module.exports = __webpack_public_path__ + "img/tenshi hinanawi_sc2.84688408.png";